import styled, { css } from "styled-components";

export const ClientTopUpContainer = styled.div`
  min-width: 1000px;
  min-height: 100vh;
  position: relative;
`;
export const ClientTopUpContent = styled.div<{ isWide: number }>`
  position: relative;
  z-index: 10;
  margin: 0 auto;
  max-width: ${(isWide) => (isWide ? "1282px" : "unset")};
  height: 100vh;
  overflow: hidden;
  pointer-events: none;
`;

export const Billboard = styled.div`
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  img {
    object-position: center;
    object-fit: cover;
    min-height: 240px;
    max-height: 288px;
    width: 100%;
  }
`;

export const CommonCardListWrapper = styled.div<{ mT?: string; pT?: string }>`
  display: flex;
  margin-top: ${(p) => p.mT || "0px"};
  padding-top: ${(p) => p.pT || "10px"};
  gap: 10px;
`;

const beforeCss = css`
  ::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: inherit;
    padding: 2px;
    box-sizing: border-box;
    background: ${(p) => p.theme["gradient-fill-2"]};
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
  }
`;
export const commonClientBalanceCardStyle = styled.div<{
  isActive: boolean;
}>`
  width: 156px;
  height: 124px;
  display: flex;
  padding: 10px;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  background: ${(p) =>
    p.isActive ? p.theme["gradient-fill-1"] : p.theme["color-fill-2"]};
  box-shadow: inset 0 0 0 1px ${(p) => p.theme["color-line-2"]};
  border-radius: 6px;
  ${(p) => p.isActive && beforeCss}

  .price-wrapper {
    font-size: 30px;
    font-weight: 700;
    height: 41px;
    line-height: 41px;
    color: ${(p) => !p.isActive && p.theme["color-text-6"]};
    background-image: ${(p) => p.isActive && p.theme["gradient-fill-6"]};
    -webkit-background-clip: ${(p) => p.isActive && "text"};
    background-clip: ${(p) => p.isActive && "text"};
    -webkit-text-fill-color: ${(p) => p.isActive && "transparent"};
    position: relative;
    z-index: 2;
    .symbol {
      font-size: 16px;
      font-weight: 700;
    }
  }
  :hover {
    ${beforeCss}
  }
`;

export const CardGift = styled.div<{ isActive: boolean }>`
  background: ${(p) =>
    p.isActive ? p.theme["color-fill-6"] : p.theme["color-fill-7"]};
  border-radius: 6px;
  width: 100%;
  color: ${(p) =>
    p.isActive ? p.theme["color-text-7"] : p.theme["color-text-6"]};
  padding: 0 8px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  box-sizing: border-box;
  margin-top: 4px;
  display: flex;
  align-items: center;
  svg {
    margin-right: 4px;
    fill: ${(p) => p.theme["color-fill-10"]};
    &.is-check-card {
      fill: ${(p) => p.theme["color-fill-9"]};
    }
  }
`;
export const GiftText = styled.div<{ isActive: boolean }>`
  display: flex;
  align-items: center;
  margin-top: 7px;
  span {
    color: ${(p) =>
      p.isActive ? p.theme["color-text-7"] : p.theme["color-text-6"]};
    font-size: 12px;
  }
`;

export const CommonTitle = styled.div`
  color: ${(p) => p.theme["color-text-1"]};
  font-size: 14px;
  font-weight: 600;
`;

export const CommonCornerMark = styled.div`
  position: absolute;
  left: 0;
  top: -10px;
  height: 24px;
  padding: 4px 12px;
  background: linear-gradient(
    92.9deg,
    #db24b3 -33.64%,
    #e139d0 18.99%,
    #ff63c1 59.87%,
    #ffa5ba 121.81%
  );
  border-radius: 6px 2px 6px 0px;
  box-sizing: border-box;
  color: #fff;
  font-weight: 600;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ActivityRuleAndCoupon = styled.div`
  position: absolute;
  right: 0;
  top: -40px;
  display: flex;
  gap: 12px;
`;
